<template>
  <div :class="['bfe', { 'bfe-invalid': error }]" :data-invalid="error ? section : null">
    <slot />
    <p v-if="error" class="error-text" role="alert">{{ error }}</p>
  </div>
</template>

<script setup>
/**
 * CADRE D'ERREUR D'UN CHAMP DE L'ANALYSE DU BESOIN.
 *
 * Pour les champs qui ne savent pas se dire en erreur eux-mêmes : les
 * questions de qualification (leur moteur de rendu sert aussi le questionnaire
 * public du client, on ne le modifie pas pour le tunnel) et la case de
 * confirmation de l'adresse e-mail. Le cadre passe leurs bordures en rouge,
 * écrit le message dessous, et porte `data-invalid` pour que le premier champ
 * en erreur soit amené sous les yeux (`focusFirstInvalid`).
 */
defineProps({
  /** Message d'erreur ; vide, le cadre ne change rien au rendu. */
  error: {
    type: String,
    default: null
  },
  /** Section à laquelle appartient le champ. */
  section: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
.bfe-invalid :deep(input:not([type='radio']):not([type='checkbox'])),
.bfe-invalid :deep(textarea),
.bfe-invalid :deep(select),
.bfe-invalid :deep(.radio-option),
.bfe-invalid :deep(.checkbox-label) {
  border-color: var(--color-danger);
}
</style>
